import React, { useState, useEffect } from 'react';

import Image from 'next/image';

import { usePostHog } from 'posthog-js/react';
import useGlobalEvent from 'beautiful-react-hooks/useGlobalEvent';

import { useEventsTracker } from 'contexts/eventsTracker';

const EmployeesForm: React.FC = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const posthog = usePostHog();
  const { trackEvent } = useEventsTracker();

  const onIframeMessage = useGlobalEvent('message');
  onIframeMessage(({ data }: MessageEvent): void => {
    if (data?.type === 'hsFormCallback' && data.eventName === 'onFormSubmit') {
      // https://posthog.com/docs/product-analytics/identify#alias-assigning-multiple-distinct-ids-to-the-same-user
      posthog.alias(data?.data.find(({ name }) => name === 'email')?.value);

      trackEvent({
        event: 'form_submit',
        form_name: `employees_${window?.location?.pathname}`,
        form_destination: window?.location?.pathname,
        form_submit_text: 'I want my employer to cover this benefit!',
        formType: 'employees',
        first_name: data?.data?.find(({ name }) => name === 'firstname')?.value,
        last_name: data?.data?.find(({ name }) => name === 'lastname')?.value,
        email: data?.data?.find(({ name }) => name === 'email')?.value,
        company: data?.data?.find(({ name }) => name === 'company')?.value,
        hr_contact_email: data?.data?.find(
          ({ name }) => name === 'hr_contact_email',
        )?.value,
      });
      setFormSubmitted(true);
    }
  });

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/v2.js';
    document.body.appendChild(script);

    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: '7790175',
          formId: 'ea281366-1d00-4180-b073-9b6752a9e026',
          target: '#employees-hubspotForm',
        });
      }
    });
  }, []);

  return (
    <div className="relative">
      <div
        id="employees-hubspotForm"
        className="border boder-gray-200 bg-lilac-50 p-6 md:p-10 rounded-lg"
      ></div>
      {!formSubmitted ? (
        <>
          <Image
            src="/about-team-1.svg"
            width={194}
            height={493}
            alt=""
            className="hidden xl:block xl:absolute xl:-scale-x-100 xl:-z-1 xl:-left-[55%] xl:top-0 xl:!w-[250px] xl:!h-[490px]"
          />
          <Image
            src="/about-team-2.svg"
            width={194}
            height={493}
            alt="Play video"
            className="hidden xl:block xl:absolute xl:-scale-x-100	xl:-z-1 xl:-right-[40%] xl:top-0"
          />
        </>
      ) : null}
    </div>
  );
};

export default EmployeesForm;
